import { Injectable, Inject } from '@angular/core';

import { Model, ModelFactory } from '@angular-extensions/model';

import { Observable, Subject } from 'rxjs';

import { IShortListItem, ShortListItem } from '../models/common-model';
import { IDerivativeSearchModel } from '../models/derivative-search-model';

const initialData: IShortListItem[] = [];

@Injectable({
  providedIn: 'root'
})
export class ShortListService {
  private _model: Model<IShortListItem[]>;
  private _modelFilters: Model<IDerivativeSearchModel>;
  private _toBasket = new Subject<IShortListItem[]>();
  private _reset = new Subject<boolean>();
  private _viewTypeChanging = false;

  active$: Observable<IShortListItem[]>;
  activeFilters$: Observable<IDerivativeSearchModel>;
  toBasket$ = this._toBasket.asObservable();
  reset$ = this._reset.asObservable();

  constructor(
    private _modelFactory: ModelFactory<IShortListItem[]>,
    private _modelFactoryFilters: ModelFactory<IDerivativeSearchModel>,
  ) {
    this._model = this._modelFactory.create(initialData);
    this.active$ = this._model.data$;

    this._modelFilters = this._modelFactoryFilters.create(null);
    this.activeFilters$ = this._modelFilters.data$;
  }

  get currentActive(): IShortListItem[] {
    return this._model.get();
  }

  add(items: IShortListItem[]): void {
    const vModels = this._model.get();

    var hasUpdates = false;

    items.forEach(item => {
      var o = vModels.findIndex(vModel => vModel.id === item.id && vModel.type === item.type && vModel.cc === item.cc);//ToDo V ?add item.modelGroups[0].modelsId
      if (o < 0) {
        hasUpdates = true;
        vModels.push(item);
      }
    });

    if (hasUpdates)
      this._model.set(vModels);
  }

  remove(items: IShortListItem[]): void {
    const vModels = this._model.get();

    var hasUpdates = false;

    items.forEach(item => {
      var o = vModels.findIndex(vModel => vModel.id === item.id && vModel.type === item.type && vModel.cc === item.cc);//ToDo V ?add item.modelGroups[0].modelsId
      if (o > -1) {
        hasUpdates = true;
        vModels.splice(o, 1);
      }
    });

    if (hasUpdates)
      this._model.set(vModels);
  }

  restoreIsSelected(items: any[]) {
    const vModels = this._model.get();

    items.forEach(item => {
      var o = vModels.findIndex(vModel => vModel.id === item.id
        && (vModel.type === item.type || vModel.type === item.derivativeType)
        && (vModel.cc === item.cc || vModel.cc === item.countryCode));//ToDo V ?add item.modelGroups[0].modelsId
      if (o > -1) {
        item.isSelected = true;
      }
    });
  }

  reset(): void {
    const vModels = this._model.get();

    vModels.length = 0;

    this._model.set(vModels);

    this._reset.next(true);
  }

  exist(item: any): boolean {
    const vModels = this._model.get();

    var o = vModels.findIndex(vModel => vModel.id === item.id
      && (/*vModel.type === item.type ||*/ vModel.type === item.derivativeType)
      && (/*vModel.cc === item.cc ||*/ vModel.cc === item.countryCode));

    return o > -1;
  }

  addToBasket(): void {
    const vModels = this._model.get();
    this._toBasket.next(vModels);
  }

  addToBasketFilter(searchFilters: IDerivativeSearchModel): void {
    this._modelFilters.set(searchFilters);
  }

  resetFilter(): void {
    this._modelFilters.set(null);
  }

  get viewTypeChanging() {
    return this._viewTypeChanging;
  }
  set viewTypeChanging(value: boolean) {
    this._viewTypeChanging = value;
  }
}                                         
